import { render, staticRenderFns } from "./BucketROI.vue?vue&type=template&id=134835e5&"
import script from "./BucketROI.vue?vue&type=script&lang=ts&"
export * from "./BucketROI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports